<template>
  
      <!-- <p class="pointer" style="position: fixed; z-index: 1000000;" :title="tools.json(ws.conn)" :style="{top, right, color: ws.online ? 'var(--online)':'var(--bad)'}">{{ws.online ? 'Online': 'Offline'}}</p>       -->
      <p class="noselect pointer hover" style="position: fixed; z-index: 1000000; top: 0px; left: 10px;" :title="tools.json(ws.conn)" :style="{color: ws.online ? 'var(--online)':'var(--bad)'}">●</p>      

</template>
<script setup>
</script>
<script>
/* eslint-disable */
import { defineComponent } from 'vue';
export default defineComponent({    
  props:{    
    top:{type:String, default:'10px'},
    right:{type:String, default:'20px'},
  },
  data() {return {}},
});

</script>
<style scoped>
.container{
   /* width: 380px;  */
   /* height: 100%;  */
   border-radius: 20px; 
   background-color: var(--g05);   
}
.messageBox{
  position: relative; 
  align-self: flex-end; 
  overflow-y: scroll; 
  width: 380px; 
  height: 100%; 
  transform: scale(1,-1); 
}
.messageList{
  padding: 15px; 
  padding-bottom: 60px; 
  transform: scale(1,1);
}
.inputBox{
  position: relative; 
  border-bottom-left-radius: 20px; 
  border-bottom-right-radius: 20px; 
  bottom: 0; 
  width: 100%;
  background-color: #1C1C1C;
}
</style>